import { render, staticRenderFns } from "./MarkdownDisplay.vue?vue&type=template&id=8754ba7a&scoped=true&"
import script from "./MarkdownDisplay.vue?vue&type=script&lang=ts&"
export * from "./MarkdownDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownDisplay.vue?vue&type=style&index=0&id=8754ba7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8754ba7a",
  null
  
)

export default component.exports